module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "Challenge-box"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.challenge),
      expression: "!challenge"
    }],
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.quizz_opened = true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('buttons.start_challenge')) + "\n  ")]), _vm._v(" "), (_vm.challenge) ? _c('router-link', {
    staticClass: "button is-warning is-size-5",
    attrs: {
      "to": {
        name: 'challenge',
        params: {
          id: _vm.challenge.slug
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n    Défi en cours "), _c('br'), _vm._v(" "), _c('time', {
    domProps: {
      "innerHTML": _vm._s(_vm.time_left)
    }
  }), _vm._v(" "), _c('span', [_vm._v("restant")])]) : _vm._e(), _vm._v(" "), (_vm.quizz_opened) ? _c('challenge-quizz', {
    on: {
      "close": function($event) {
        _vm.quizz_opened = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28ad1347","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChallengeBox.vue
// module id = 353
// module chunks = 9